import { handleResult } from '@/helpers/utils/functionality-utils';
import { userModule } from '@/module/userModule';
import ApiService, { type RequestOptions } from '@/services/apiService';
import type { MyNotification } from '@/types/user/notification-types';

export class NotificationService {
  private userApiService: ApiService;
  constructor() {
    this.userApiService = new ApiService(userModule);
  }
  async getMyNotifications(data: RequestOptions['params']) {
    const response = await this.userApiService.get<MyNotification[]>(
      `/api/v1/auth/notifications`,
      data,
    );
    return handleResult(response);
  }
}
